import type { Field, FieldByUuid, Operation } from 'store/types/types';

type OperationKeysForFields = 'operationId' | 'operationName';
type FieldFromOL = Omit<Field, OperationKeysForFields | 'id'> & { id: number };
export type OperationFromOL = Pick<Operation, OperationKeysForFields> & {
  userId: string;
  fields: {
    nodes: FieldFromOL[];
  };
};
type ParsedFields = {
  byId: {
    [id: string]: Field;
  };
  byUuid: FieldByUuid;
};

export const parseFields = ({ operations }: { operations: OperationFromOL[] }) => {
  return operations.reduce(
    (parsedFields, { fields, operationId, operationName, userId }) => {
      fields.nodes.forEach((field) => {
        const parsedField = {
          ...field,
          id: field.id.toString(),
          operationId,
          operationName,
          userId
        };

        parsedFields.byId[field.id] = parsedField;
        parsedFields.byUuid[field.uuid] = parsedField;
      });
      return parsedFields;
    },
    { byId: {}, byUuid: {} } as ParsedFields
  );
};
